/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable, inject } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'
import { BASE_PATH } from '@myprofile-ui/pidx-utils'

@Injectable({
  providedIn: 'root',
})
export class AddressService {
  private httpClient = inject(HttpClient)
  private basePath = inject(BASE_PATH)

  public getAllAddressesForProfile(country: string, language: string, header?: HttpHeaders): Observable<AddressDto[]> {
    const headers = header ? header.set('accept-language', language) : new HttpHeaders({ 'accept-language': language })
    return this.httpClient.get<AddressDto[]>(`${this.basePath}/addresses?country=${country}`, { headers: headers })
  }

  public createAddressForProfile(country: string, language: string, dto: AddressDto, header?: HttpHeaders): Observable<AddressDto> {
    const headers = header ? header.set('accept-language', language) : new HttpHeaders({ 'accept-language': language })
    return this.httpClient.post<AddressDto>(`${this.basePath}/addresses?country=${country}`, dto, { headers: headers })
  }

  public deleteAddressForProfile(country: string, language: string, addressId: string, header?: HttpHeaders): Observable<void> {
    const headers = header ? header.set('accept-language', language) : new HttpHeaders({ 'accept-language': language })
    return this.httpClient.delete<void>(`${this.basePath}/addresses/${addressId}?country=${country}`, { headers: headers })
  }

  public deleteTmpAddressForProfile(country: string, language: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.basePath}/addresses/tmpaddress?country=${country}`, {
      headers: { 'accept-language': language },
    })
  }

  public updateAddressForProfile(country: string, language: string, dto: AddressDto, header?: HttpHeaders): Observable<AddressDto> {
    const headers = header ? header.set('accept-language', language) : new HttpHeaders({ 'accept-language': language })
    return this.httpClient.put<AddressDto>(`${this.basePath}/addresses/${dto.addressId}?country=${country}`, dto, {
      headers: headers,
    })
  }
}
export interface AddressDto {
  addressId?: string
  buildingCode?: string
  ciamId?: string
  city?: string
  coName?: string
  companyName1?: string
  companyName2?: string
  country?: string
  district?: string
  floor?: string
  formattedAddress?: string
  houseNumber?: string
  isStandard?: boolean
  poBox?: string
  poBoxCity?: string
  poBoxPostalCode?: string
  postalCode?: string
  postalCodeRegion?: string
  postalCodeRegionValue?: string
  roomNumber?: string
  street1?: string
  street2?: string
  street3?: string
  supplement?: string
  type?: string
  usage?: 'home' | 'work'
  vatId?: string
  taxNumber?: string
  tempAddressId?: string
  formatted?: string
}
